<!-- This example requires Tailwind CSS v2.0+ -->
<template>
  <div
    :class="`max-w-sm w-full bg-${color}-100 shadow-lg rounded-lg pointer-events-auto overflow-hidden z-50`"
  >
    <div class="p-4">
      <div class="flex" :class="{ 'items-start': description, 'items-center': !description }">
        <div class="shrink-0">
          <component :is="icon" :class="`h-6 w-6 text-${color}-400`" aria-hidden="true" />
        </div>
        <div class="ml-3 w-0 flex-1 pt-0.5">
          <p :class="`text-sm font-medium text-${color}-600`">
            <slot>{{ title }}</slot>
          </p>
          <p v-if="description" :class="`mt-1 text-sm text-${color}-600`">
            {{ description }}
          </p>
        </div>
        <div class="ml-4 shrink-0 flex">
          <button
            :class="`inline-flex bg-${color}-100 rounded-md p-1.5 text-${color}-500 hover:bg-${color}-200 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-offset-${color}-100 focus:ring-${color}-600`"
            @click="close"
          >
            <span class="sr-only">Close</span>
            <XIcon class="h-5 w-5" aria-hidden="true" />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'
const colors = {
  error: 'red',
  success: 'green',
}
const icons = {
  error: 'SolidXCircleIcon',
  success: 'SolidCheckCircleIcon',
}
export default {
  name: 'Toast',
  inject: ['$toast'],
  props: {
    id: {
      type: Number,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'success',
      validator: (value) => {
        return ['error', 'success'].includes(value)
      },
    },
  },
  setup(props) {
    // const show = ref(true)
    const color = computed(() => {
      return colors[props.type]
    })
    const icon = computed(() => {
      return icons[props.type]
    })
    return {
      // show,
      color,
      icon,
    }
  },
  methods: {
    close() {
      this.$toast.close(this.id)
    },
  },
}
</script>
